import { inject } from 'inversify';
import { urlMaker } from '@core/utils';
import { IRepo, IRepoResponse } from '@core/repo';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { bind } from '@infra/container';
import { IDeclarationPost } from '../interfaces';
import { DeclarationPostMapper } from './../mappers';
export type IGetDeclarationsPostRepoResponse = IRepoResponse<200, { data: IDeclarationPost[]; total: number }> | IRepoResponse<400 | 500, string>;

export type IGetDeclarationsPostRepo = IRepo<[any], IGetDeclarationsPostRepoResponse>;

export const GetDeclarationsPostRepoType = Symbol.for('GetDeclarationsPostRepo');

@bind(GetDeclarationsPostRepoType)
export class GetDeclarationsPostRepo implements IGetDeclarationsPostRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(query: object) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/post_declarations', query) });
      if (result.status === 200) {
        const data: IDeclarationPost[] = result.data.data.map((item) => DeclarationPostMapper.toDomain(item));
        const total: number = result.data.total;

        return {
          status: 200 as 200,
          response: {
            data,
            total,
          },
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi',
      };
    }
  }
}
